"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportValues = void 0;
const react_1 = require("react");
const useSubject_1 = require("../_hooks/useSubject");
const order_1 = require("../modules/order");
function useImportValues({ paramList }, props) {
    const { handleImportFlat, handleImportOrderItem } = props !== null && props !== void 0 ? props : {};
    const [importValues, setImportValues, importValues$] = (0, useSubject_1.useBehaviorSubject)(null);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            if ((paramList === null || paramList === void 0 ? void 0 : paramList.length) > 0) {
                if (handleImportFlat) {
                    const values = yield handleImportFlat();
                    setImportValues(values);
                }
                else if (handleImportOrderItem) {
                    const orderItem = yield handleImportOrderItem();
                    const values = (0, order_1.fromOrderItemToValues)(orderItem, paramList);
                    setImportValues(values);
                }
            }
        }))();
    }, [handleImportFlat, handleImportOrderItem, importValues$, paramList, setImportValues]);
    return { importValues, importValues$ };
}
exports.useImportValues = useImportValues;
